"use client"

import { useEffect } from "react"
import { errorTracking, ErrorBoundary } from "@/lib/error-tracking"
import { ErrorFallback } from "@/components/error-fallback"

interface ErrorTrackingProviderProps {
  children: React.ReactNode
  user?: {
    id: string | number
    email?: string
    name?: string
    currentOrganization?: {
      organization_id: string | number
      role: string
    }
  } | null
}

export function ErrorTrackingProvider({ children, user }: ErrorTrackingProviderProps) {
  // Initialize error tracking on mount
  useEffect(() => {
    errorTracking.init({})
  }, [])

  // Update user context when user changes
  useEffect(() => {
    if (user) {
      errorTracking.setUser({
        id: String(user.id), // Convert to string
        email: user.email,
        name: user.name,
        organizationId: user.currentOrganization
          ? String(user.currentOrganization.organization_id)
          : undefined,
        role: user.currentOrganization?.role
      })
    } else {
      errorTracking.setUser(null)
    }
  }, [user])

  // If ErrorBoundary is not available (e.g., in development without Rollbar token),
  // just render children
  if (!ErrorBoundary) {
    return <>{children}</>
  }

  return <ErrorBoundary fallback={ErrorFallback}>{children}</ErrorBoundary>
}
